import startOfWeek from '../../node_modules/date-fns/esm/startOfWeek/index.js';
import startOfDay from '../../node_modules/date-fns/esm/startOfDay/index.js';
import eachDayOfInterval from '../../node_modules/date-fns/esm/eachDayOfInterval/index.js';
import startOfMonth from '../../node_modules/date-fns/esm/startOfMonth/index.js';
import endOfMonth from '../../node_modules/date-fns/esm/endOfMonth/index.js';
import endOfDay from '../../node_modules/date-fns/esm/endOfDay/index.js';
import endOfDecade from '../../node_modules/date-fns/esm/endOfDecade/index.js';
import isAfter from '../../node_modules/date-fns/esm/isAfter/index.js';
import isBefore from '../../node_modules/date-fns/esm/isBefore/index.js';
import isSameDay from '../../node_modules/date-fns/esm/isSameDay/index.js';
import isSameMonth from '../../node_modules/date-fns/esm/isSameMonth/index.js';
import lastDayOfWeek from '../../node_modules/date-fns/esm/lastDayOfWeek/index.js';
import setMonth from '../../node_modules/date-fns/esm/setMonth/index.js';
import setYear from '../../node_modules/date-fns/esm/setYear/index.js';
import startOfDecade from '../../node_modules/date-fns/esm/startOfDecade/index.js';
import utcToZonedTime from '../../node_modules/date-fns-tz/esm/utcToZonedTime/index.js';
import zonedTimeToUtc from '../../node_modules/date-fns-tz/esm/zonedTimeToUtc/index.js';
import { chunk } from '../../utils/utils.js';
import __vue_component__ from './CalendarHeader.vue.js';
import __vue_component__$1 from './Weeks.vue.js';
import __vue_component__$2 from './Months.vue.js';
import __vue_component__$3 from './Years.vue.js';

//
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const DAYS_IN_WEEK = 7;
const TODAY = new Date();
var script = {
  name: 'DatePicker',
  components: {
    CalendarHeader: __vue_component__,
    Weeks: __vue_component__$1,
    Months: __vue_component__$2,
    Years: __vue_component__$3
  },
  props: {
    value: {
      type: [Date, Object],
      default: () => undefined
    },
    rangeValue: {
      type: Boolean,
      default: false
    },
    disabledRange: {
      type: Object,
      default: () => ({
        from: undefined,
        to: undefined
      })
    },
    visibleDate: {
      type: Date,
      default: undefined
    },
    timeZone: {
      type: String,
      default: undefined
    }
  },

  data() {
    return {
      today: TODAY,
      currentDate: undefined,
      selectedDate: undefined,
      currentInterval: 'days'
    };
  },

  computed: {
    weeks() {
      return this.daysOfMonth;
    },

    month() {
      return MONTHS[this.currentDate.getMonth()];
    },

    year() {
      return this.currentDate.getFullYear();
    },

    decade() {
      const firstYearOfDecade = startOfDecade(this.currentDate).getFullYear();
      const lastYearOfDecade = endOfDecade(this.currentDate).getFullYear();
      return `${firstYearOfDecade} - ${lastYearOfDecade}`;
    },

    daysOfMonth() {
      const monthFirstDate = startOfMonth(this.currentDate);
      const monthLastDate = endOfMonth(this.currentDate);
      const daysOfMonth = eachDayOfInterval({
        start: startOfWeek(monthFirstDate),
        end: lastDayOfWeek(monthLastDate)
      });
      const enrichedDays = daysOfMonth.map(day => this.enrichDay(day));
      return chunk(enrichedDays, DAYS_IN_WEEK);
    },

    yearsOfDecade() {
      const start = startOfDecade(this.currentDate).getFullYear();
      const end = endOfDecade(this.currentDate).getFullYear();
      return Array(end - start + 1).fill().map((_, idx) => start + idx);
    },

    disabledFrom() {
      return this.disabledRange && this.disabledRange.from && startOfDay(this.disabledRange.from);
    },

    disabledTo() {
      return this.disabledRange && this.disabledRange.to && endOfDay(this.disabledRange.to);
    },

    rangeFrom() {
      return this.value && this.rangeValue && startOfDay(this.value.from);
    },

    rangeTo() {
      return this.value && this.rangeValue && endOfDay(this.value.to);
    }

  },
  watch: {
    value: {
      handler(date) {
        const selectedDate = this.rangeValue ? date.from : date;
        this.selectedDate = selectedDate ? utcToZonedTime(selectedDate, this.timeZone) : undefined;
      },

      immediate: true
    },
    visibleDate: {
      handler() {
        this.currentDate = this.visibleDate || this.selectedDate || TODAY;
      },

      immediate: true
    }
  },
  methods: {
    enrichDay(date) {
      return {
        date,
        isToday: this.isToday(date),
        isNotSameMonth: !isSameMonth(this.currentDate, date),
        isSelected: this.isSelected(date),
        isDisabled: this.isDisabled(date),
        isHighlighted: this.isHighlighted(date),
        isRangeStart: isSameDay(date, this.rangeFrom),
        isRangeEnd: isSameDay(date, this.rangeTo)
      };
    },

    isToday(date) {
      return isSameDay(utcToZonedTime(new Date(), this.timeZone), date);
    },

    isSelected(date) {
      if (this.rangeValue) {
        return isSameDay(date, this.value.from) || isSameDay(date, this.value.to);
      }

      return isSameDay(this.selectedDate, date);
    },

    isDisabled(date) {
      if (!this.disabledFrom && !this.disabledTo) {
        return false;
      }

      if (!this.disabledFrom) {
        return !isAfter(date, this.disabledTo);
      }

      if (!this.disabledTo) {
        return !isBefore(date, this.disabledFrom);
      }

      if (isAfter(this.disabledTo, this.disabledFrom)) {
        return !isAfter(date, this.disabledTo) && !isBefore(date, this.disabledFrom);
      }

      return isBefore(date, this.disabledTo) || isAfter(date, this.disabledFrom);
    },

    isHighlighted(date) {
      if (!this.rangeValue) {
        return false;
      }

      return isAfter(date, this.rangeFrom) && isBefore(date, this.rangeTo);
    },

    onNext(callback) {
      this.currentDate = callback(this.currentDate, this.currentInterval);
    },

    onPrev(callback) {
      this.currentDate = callback(this.currentDate, this.currentInterval);
    },

    onMonthSelected(month) {
      this.currentInterval = 'days';
      this.currentDate = setMonth(this.currentDate, month);
    },

    onYearSelected(year) {
      this.currentInterval = 'months';
      this.currentDate = setYear(this.currentDate, year);
    },

    onDateSelected(day) {
      const {
        date
      } = day;

      if (this.selectedDate) {
        date.setHours(this.selectedDate.getHours());
        date.setMinutes(this.selectedDate.getMinutes());
        date.setSeconds(this.selectedDate.getSeconds());
      }

      this.selectedDate = date;
      this.currentDate = date;
      const utcDate = zonedTimeToUtc(date, this.timeZone);
      this.$emit('date-selected', utcDate);
    },

    onIntervalChange(interval) {
      this.currentInterval = interval;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Calendar/Calendar.vue_rollup-plugin-vue=script.js